<template>
  <div class="mt-6">
    <p class="mb-4">
      {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.DESCRIPTION') }}
    </p>
    <woot-button
      color-scheme="primary"
      :is-loading="isAuthenticating || isProcessing"
      @click="handleStart"
    >
      {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.START_BUTTON') }}
    </woot-button>
  </div>
</template>

<script>
import {
  setupFacebookSdk,
  initWhatsAppEmbeddedSignup,
  createMessageHandler,
  isValidBusinessData,
} from './whatsapp/utils';
import router from '../../../../index';

export default {
  data() {
    return {
      authCode: null,
      businessData: null,
      isAuthenticating: false,
      isProcessing: false,
      messageHandler: null,
    };
  },
  mounted() {
    this.messageHandler = createMessageHandler(this.handleEmbeddedSignupMessage);
    window.addEventListener('message', this.messageHandler);
  },
  beforeDestroy() {
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
    }
  },
  methods: {
    async handleStart() {
      if (this.isAuthenticating || this.isProcessing) return;
      try {
        this.isAuthenticating = true;
        const { whatsappAppId, whatsappApiVersion, whatsappConfigurationId } =
          window.chatwootConfig || {};

        if (!whatsappAppId || !whatsappApiVersion || !whatsappConfigurationId) {
          throw new Error(
            this.$t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MISSING_CONFIG')
          );
        }

        await setupFacebookSdk(whatsappAppId, whatsappApiVersion);
        this.authCode = await initWhatsAppEmbeddedSignup(
          whatsappConfigurationId
        );

        // eslint-disable-next-line no-console
        console.log(
          '[WA_EMBEDDED_SIGNUP][component] Auth code recibido desde FB.login',
          { tieneBusinessData: Boolean(this.businessData) }
        );

        // Si ya teníamos los datos de negocio cuando llega el authCode,
        // completamos el flujo ahora.
        if (this.businessData) {
          // eslint-disable-next-line no-console
          console.log(
            '[WA_EMBEDDED_SIGNUP][component] businessData ya presente al recibir authCode, llamando a completeSignupFlow()'
          );
          this.completeSignupFlow();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('WhatsApp Embedded Signup failed', error);
        this.$toast.error(
          error.message ||
            this.$t(
              'INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.GENERIC_ERROR_MESSAGE'
            )
        );
      } finally {
        this.isAuthenticating = false;
      }
    },

    handleEmbeddedSignupMessage(payload) {
      if (!payload) return;

      // eslint-disable-next-line no-console
      console.log(
        '[WA_EMBEDDED_SIGNUP][component] handleEmbeddedSignupMessage payload recibido',
        payload
      );

      // El payload estándar trae { type: 'WA_EMBEDDED_SIGNUP', event, data: { business_id, waba_id, phone_number_id } }
      const data = payload.data || payload;

      // eslint-disable-next-line no-console
      console.log(
        '[WA_EMBEDDED_SIGNUP][component] Datos de negocio extraídos del payload',
        data
      );

      if (!isValidBusinessData(data)) {
        // eslint-disable-next-line no-console
        console.log(
          '[WA_EMBEDDED_SIGNUP][component] Datos de negocio no son válidos, se ignora el mensaje'
        );
        // ignoramos mensajes que no traen datos de negocio completos
        return;
      }

      // eslint-disable-next-line no-console
      console.log(
        '[WA_EMBEDDED_SIGNUP][component] Datos de negocio válidos, guardando en estado y comprobando authCode',
        {
          authCodePresente: Boolean(this.authCode),
          businessData: data,
        }
      );

      this.businessData = data;
      if (this.authCode) {
        // eslint-disable-next-line no-console
        console.log(
          '[WA_EMBEDDED_SIGNUP][component] authCode ya presente, iniciando completeSignupFlow()'
        );
        this.completeSignupFlow();
      } else {
        if (this.$toast && this.$toast.info) {
          this.$toast.info(
            this.$t(
              'INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.WAITING_FOR_AUTH_CODE'
            )
          );
        } else {
          // eslint-disable-next-line no-console
          console.log(
            '[WA_EMBEDDED_SIGNUP][component] Toast no disponible, esperando authCode'
          );
        }
      }
    },

    async completeSignupFlow() {
      if (!this.authCode || !this.businessData) return;

      this.isProcessing = true;
      try {
        const params = {
          code: this.authCode,
          waba_id: this.businessData.waba_id,
        };

        // business_id puede venir en ambos flujos (Cloud API y Business App)
        if (this.businessData.business_id) {
          params.business_id = this.businessData.business_id;
        }

        // phone_number_id solo viene en el flujo clásico de Cloud API.
        // En el flujo de WhatsApp Business App onboarding NO viene y
        // el backend debe resolver el número a partir del waba_id.
        if (this.businessData.phone_number_id) {
          params.phone_number_id = this.businessData.phone_number_id;
        }

        const inbox = await this.$store.dispatch(
          'inboxes/createWhatsAppEmbeddedSignup',
          params
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: inbox.id,
          },
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error completing WhatsApp Embedded Signup', error);
        if (this.$toast && this.$toast.error) {
          this.$toast.error(
            error.message ||
              this.$t(
                'INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.COMPLETION_ERROR_MESSAGE'
              )
          );
        }
      } finally {
        this.isProcessing = false;
      }
    },
  },
};
</script>


